import { FGDivider, FGIcons, FGLink, FGStack, FGTypography } from '@fg/design-system';
import React from 'react';

type Props = {
    headline: string;
    onBack: () => void;
};

const PrimaryArticleBar = React.memo(({ headline, onBack }: Props) => (
    <>
    <FGLink
        className="primary-article-link"
        style={{ color: 'var(--fg-color-base-blue-12)'}}
        isButton
        onClick={onBack}>
        <FGStack gap={8} alignItems="center">
            <FGIcons icon="ArrowLeft" size={16} />
            <FGTypography
                tag="label"
                variant="link2"
                alignment="left"
                cssStyle={{ cursor: 'pointer' }}>
                {headline}
            </FGTypography>
        </FGStack>
    </FGLink>
    <div style={{ marginBlock: 16 }}>
        <FGDivider />
    </div>
    </>
    
));

export default PrimaryArticleBar;
